var cifNe = ["301 259", "<g fill='none'><path fill='#0DB02B' d='M.5.928h300v257.143H.5z'/><path fill='#FFF' d='M.5.928h300v171.429H.5z'/><path fill='#E05206' d='M.5.928h300v85.714H.5z'/><circle cx='150.5' cy='129.5' r='36.429' fill='#E05206'/></g>"];

export { cifNe };

